import zoomInIcon from "../../../../../../assets/images/zoom-in.svg";
import zoomOutIcon from "../../../../../../assets/images/zoom-out.svg";

export const ZoomableSchedule = ({
    handleZoomIn,
    handleZoomOut,
    timeSlots,
    zoomInOut,
    weeklyView
}) => {
    return (
        <div className={`border-middle-container rounded border-0 ${weeklyView && "py-0"}`}>
            <div className="middle-up row justify-content-center">
                <div class="d-flex flex-column align-items-center zoom col-2">
                    <a class="btn-circle" onClick={handleZoomIn}>
                        <img src={zoomInIcon} width={16}/>
                    </a>
                    <div class="vertical-line my-2" style={{
                        height: `${weeklyView ? "0.3rem" : "3.5rem"}`
                    }}></div>
                    <a class="btn-circle" onClick={handleZoomOut}>
                        <img src={zoomOutIcon} width={16}/>
                    </a>
                </div>
            </div>
        </div>
    )
}